import { AUTH_BASE_URL } from '../config/api';

const BASE_URL = AUTH_BASE_URL;

export const fetchUsers = async () => {
  const response = await fetch(`${BASE_URL}/api/users`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch users');
  }

  return response.json();
};

export const fetchUserCredits = async () => {
  const response = await fetch(`${BASE_URL}/api/users/credits`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch credits');
  }

  return response.json();
};

export const inviteUser = async (email, teamId = null) => {
  const response = await fetch(`${BASE_URL}/api/users/invite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, teamId }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to send invitation');
  }

  return response.json();
};

export const fetchInvitations = async () => {
  const response = await fetch(`${BASE_URL}/api/users/invitations`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch invitations');
  }

  return response.json();
};

export const updateUserStatus = async (userId, status) => {
  const response = await fetch(`${BASE_URL}/api/users/${userId}/status`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ status }),
  });

  if (!response.ok) {
    throw new Error('Failed to update user status');
  }

  return response.json();
};

export const updateUserCredits = async (userId, monthlyCredits) => {
  const response = await fetch(`${BASE_URL}/api/users/${userId}/credits`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ monthlyCredits }),
  });

  if (!response.ok) {
    throw new Error('Failed to update user credits');
  }

  return response.json();
};

export const updateUserAdminStatus = async (userId, isAdmin, isSuperAdmin = false) => {
  const response = await fetch(`${BASE_URL}/api/users/${userId}/admin`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ isAdmin, isSuperAdmin }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to update user admin status');
  }

  return response.json();
};

export const manageUserCredits = async (userId, action, data) => {
  const response = await fetch(`${BASE_URL}/api/users/${userId}/credits/manage`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ action, ...data }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to manage user credits');
  }

  return response.json();
};

export const resetUserCredits = async (userId) => {
  const response = await fetch(`${BASE_URL}/api/users/${userId}/credits/reset`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to reset user credits');
  }

  return response.json();
};